import CalendarDayRecord from '@/components/ezuro/workschedule/components/CalendarDayRecord.vue';
import moment from 'moment';

export default {
  name: 'CalendarDay',
  props: {
    day: {
      type: Object
    },
    filterData: {
      type: Object
    },
    scheduleData: {
      type: Object
    },
    notes: {
      type: Array
    },
    section: {
      type: String
    }
  },
  components: {
    CalendarDayRecord
  },
  data () {
    return {
      showNotes: (this.notes && this.notes.length)
    };
  },
  computed: {
    records () {
      const records = [];

      if (this.day) {
        for (const key in this.scheduleData.records) {
          if (moment(this.scheduleData.records[key].datetime_start).format('YYYY-MM-DD') === this.day.sql_day) {
            records.push(this.scheduleData.records[key]);
          }
        }
      }

      return records;
    },
    editable () {
      let scheduleConfirmed = false;

      if (this.scheduleData.schedules.length) {
        scheduleConfirmed = true;

        for (const key in this.scheduleData.schedules) {
          if (this.scheduleData.schedules[key].status != 'confirmed') {
            scheduleConfirmed = false;
            break;
          }
        }
      }

      return this.section !== 'list-my' && !scheduleConfirmed;
    }
  },
  methods: {
    editRecord: function (record) {
      this.$emit('editRecord', record);
    },
    addRecord: function () {
      const record = {
        id: null,
        user_id: null,
        shift_id: null,
        work_from_home: false,
        datetime_start: this.day.sql_day + ' 08:00',
        datetime_end: this.day.sql_day + ' 18:00',
        notes: '',
        type: this.filterData.type,
        schedule_id: null
      };

      if (this.filterData.department_id.length === 1) {
        record.department_id = this.filterData.department_id[0];
      }

      if (this.filterData.division_id.length === 1) {
        record.division_id = this.filterData.division_id[0];
      }

      this.$emit('addRecord', { record: record, allowMultiDepartmentSelect: true });
    },
    addNotes: function () {
      this.$emit('addNotes', this.day.sql_day);
    }
  },
  watch: {
    notes: {
      immediate: true,
      handler () {
        this.showNotes = false;
        this.$nextTick(() => {
          this.showNotes = (this.notes && this.notes.length);
        });
      }
    }
  }
}
